import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { TopicListItem } from "../types";

interface UseTopicsListArgs {
  corporateId: string;
  initiativeId: number;
  page: number;
  pageSize: number;
  search?: string;
}

export const useTopicsList = ({
  corporateId,
  initiativeId,
  page,
  pageSize,
  search,
}: UseTopicsListArgs): PaginatedListResult<TopicListItem> => {
  const url =
    corporateId && initiativeId
      ? `${ServicesURL.topics}/${initiativeId}/topics?corporate_id=${corporateId}`
      : null;

  return usePaginatedList<TopicListItem>(url, {
    page,
    pageSize,
    search,
    sort: "asc",
  });
};
